export default {
	SET_BOOKING_HISTORY_ADDRESS: (state, data) => {
        state.bookingHistoryAddress = data;
    },
}